<ng-container *transloco="let t">
  @if (
    {
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <ng-container [formGroup]="globalGoalsFormGroup">
      <lib-input-container
        [errorText]="
          !data.readOnly
            ? errorMessage(globalGoalsFormGroup.controls.goals)
            : ''
        "
        [required]="!data.readOnly"
      >
        <div
          class="error-border"
          [ngClass]="{
            'active-error':
              !data.readOnly &&
              validateControl(
                globalGoalsFormGroup.controls.goals,
                ['validGlobalGoals'],
                []
              ),
          }"
        >
          <lib-input-container
            description=""
            required="true"
            [label]="t('question_agenda_select_main_goal')"
          >
            <div class="global-goal-container">
              @for (goal of globalGoals(); track goal.code) {
                <div [class]="isMobile() ? 'row no-gutters' : 'no-gutters'">
                  <button
                    [attr.id]="'id-' + goal.code"
                    [attr.aria-description]="
                      errorMessage(globalGoalsFormGroup.controls.goals)
                    "
                    [class]="
                      isMobile()
                        ? 'global-goal-button col-2'
                        : 'global-goal-button'
                    "
                    [class.selected]="!data.readOnly && goal.selected === true"
                    (click)="selectMainGoal(goal)"
                    [disabled]="data.readOnly"
                    (keydown)="onKeyDown($event, goal)"
                    [attr.aria-label]="
                      t('question_agenda_selected_main_goal') + activeLang ===
                      'sv'
                        ? goal.nameSv
                        : goal.nameEn
                    "
                  >
                    <img
                      [title]="activeLang === 'sv' ? goal.nameSv : goal.nameEn"
                      [alt]="activeLang === 'sv' ? goal.nameSv : goal.nameEn"
                      [src]="
                        '/assets/formrenderer/' +
                        (activeLang === 'sv' ? goal.linkSv : goal.linkEn)
                      "
                    />
                  </button>
                  <span class="d-md-none global-goal-text col-8">{{
                    activeLang === 'sv' ? goal.nameSv : goal.nameEn
                  }}</span>
                </div>
                <div class="d-md-none">
                  @if (goal.selected && isMobile()) {
                    <lib-vinnova-checkboxes
                      [attr.id]="'id-' + goal.code"
                      required="true"
                      [checkboxObjects]="checkboxOptions(goal.subGoals)"
                      [formControl]="
                        globalGoalsFormGroup.get('goals').at(goal.code - 1)
                      "
                      extendedDisabling="true"
                    >
                    </lib-vinnova-checkboxes>
                  }
                </div>
              }
            </div>
          </lib-input-container>
          @if (!data.readOnly) {
            <div class="global-goal-container d-none d-md-block">
              @if (hasSelectedMainGoal) {
                <lib-input-container
                  [label]="t('question_agenda_select_sub_goal')"
                  required="false"
                >
                </lib-input-container>
              }
              @for (goal of globalGoals(); track goal.code) {
                @if (goal.selected && !isMobile()) {
                  <lib-input-container
                    required="true"
                    [headLine]="
                      goal.code +
                      ' ' +
                      (activeLang === 'sv' ? goal.nameSv : goal.nameEn)
                    "
                  >
                    <lib-vinnova-checkboxes
                      class="global-goal-checkbox"
                      [attr.id]="'id-' + goal.code"
                      required="true"
                      [checkboxObjects]="checkboxOptions(goal.subGoals)"
                      [formControl]="
                        globalGoalsFormGroup.get('goals').at(goal.code - 1)
                      "
                      extendedDisabling="true"
                    >
                    </lib-vinnova-checkboxes>
                  </lib-input-container>
                }
              }
            </div>
          }
          <div class="global-goal-container">
            @if (chosenGoals().length > 0) {
              <lib-input-container
                [label]="t('question_agenda_selected_goals')"
                required="false"
              >
                <lib-list>
                  @for (goal of chosenGoals(); track goal.code) {
                    <lib-list-item
                      [removeVisible]="!data.readOnly"
                      (remove)="removeSubGoal(goal.code)"
                      (keydown.enter)="removeSubGoal(goal.code)"
                    >
                      <div view-title class="choosen-item">
                        <span class="choosen-label">{{
                          activeLang === 'sv' ? goal.nameSv : goal.nameEn
                        }}</span>
                      </div>
                    </lib-list-item>
                  }
                </lib-list>
              </lib-input-container>
            }
          </div>
        </div>
      </lib-input-container>
    </ng-container>
  }
</ng-container>
